const mergeArrays = arr => {
  return [].concat.apply([], arr);
};

export default mergeArrays;
